import { getDashboardData } from 'modules/society/actions/dashBoardActions';

export const getPartnersViewData = async (societyId, dispatch) => {
  const partnersData = await dispatch(getDashboardData(societyId, 'partners'));
  return partnersData;
};
